
function BottomBar() {
  return (
    <div className="flex flex-row fixed bottom-0 bg-[black] w-full text-[white] p-3 justify-between text-[13px] md:text-[10px]">
      <div className="font-bold">© 2025 주식회사 코리아트래블스토어</div>
      <div className="font-bold">이용문의 | 010-8412-8521 | v1.0.2</div>
    </div>
  );
}

export default BottomBar;
